// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ToastContainer-module__Container__xvn6X {
    display: flex;
    flex-direction: column;
    gap: var(--ds-gap-sm);
    /* Right margin clears an open Drawer (--ds-drawer-width is 0px when none). */
    margin: auto calc(var(--ds-drawer-width) + var(--ds-xl)) var(--ds-xl) auto;
    background: none;
    border: none;
}

.ToastContainer-module__NoContent__q2kQz {
    padding: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `ToastContainer-module__Container__xvn6X`,
	"NoContent": `ToastContainer-module__NoContent__q2kQz`
};
export default ___CSS_LOADER_EXPORT___;
